import { Routes } from '@angular/router';
import { providePackageStore } from '@app/store/package';
import { providePredefinedPricingTiersStore } from '@app/store/predefined-pricing-tiers';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { EditComponent } from './edit/edit.component';
import { ViewComponent } from './view/view.component';

export const packagesModalRoutes: Routes = [
    {
        path: 'packages/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...providePackageStore(), ...providePredefinedPricingTiersStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'packages/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...providePackageStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'packages/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...providePackageStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
